/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const buttonTokens = {
  BackgroundColorBaseDefault: '#ffffff',
  BackgroundColorPrimaryDefault: '#232b2b',
  BackgroundColorPrimaryHover: '#394040',
  BackgroundColorPrimaryDown: '#1a3e6d',
  BackgroundColorPrimaryDisabled: '#dedfdf',
  BackgroundColorSecondaryDefault: '#ffffff',
  BackgroundColorSecondaryHover: '#ffffff',
  BackgroundColorSecondaryDown: '#ffffff',
  BackgroundColorSecondaryDisabled: '#ffffff',
  BackgroundColorDangerDefault: '#c41936',
  BackgroundColorDangerHover: '#da1c3c',
  BackgroundColorDangerDown: '#ae1630',
  BackgroundColorDangerDisabled: '#f8d2d8',
  BackgroundColorTransparentDefault: 'rgba(0, 0, 0, 0)',
  BackgroundColorPlusDefault: '#232b2b',
  BackgroundColorPlusHover: '#394040',
  BackgroundColorPlusDown: '#1a3e6d',
  BackgroundColorMinusDefault: '#ffffff',
  BackgroundColorMinusHover: '#ffffff',
  BackgroundColorMinusDown: '#ffffff',
  BackgroundColorMinusDisabled: '#ffffff',
  BackgroundColorInverseDefault: '#ffffff',
  BackgroundColorInverseHover: '#ffffff',
  BackgroundColorActionsDefault: 'rgba(0, 0, 0, 0)',
  BackgroundColorActionsDown: 'rgba(21, 22, 26, .1)',
  BackgroundColorActionsInTableRowHover: '#dedfdf',
  BackgroundColorActionsInTableColoredRowHover: 'rgba(255, 255,255, 0.5)',
  BackgroundColorFilterDefault: '#ffffff',
  BackgroundColorFilterHover: '#ffffff',
  BackgroundColorFilterDown: '#ffffff',
  BackgroundColorFilterDisabled: '#ffffff',
  BorderRadiusBaseDefault: '8px',
  BorderRadiusBaseSmall: '4px',
  BorderRadiusLinkDefault: '4px',
  BorderRadiusPlusDefault: '4px',
  BorderRadiusMinusDefault: '4px',
  BorderRadiusMiniDefault: '4px',
  BorderRadiusFilterDefault: '24px',
  BorderStyleBaseDefault: 'solid',
  BorderWidthBaseDefault: '1px',
  BorderColorBaseDefault: 'rgba(0, 0, 0, 0)',
  BorderColorBaseKeyboardFocus: '#285da3',
  BorderColorPrimaryDefault: 'rgba(0, 0, 0, 0)',
  BorderColorPrimaryHover: 'rgba(0, 0, 0, 0)',
  BorderColorSecondaryDefault: '#c4c4c4',
  BorderColorSecondaryHover: '#394040',
  BorderColorSecondaryDown: '#1a3e6d',
  BorderColorDangerDefault: 'rgba(0, 0, 0, 0)',
  BorderColorDangerHover: 'rgba(0, 0, 0, 0)',
  BorderColorDangerKeyboardFocus: '#831124',
  BorderColorTransparentDefault: 'rgba(0, 0, 0, 0)',
  BorderColorPlusDefault: 'rgba(0, 0, 0, 0)',
  BorderColorPlusHover: 'rgba(0, 0, 0, 0)',
  BorderColorMinusDefault: '#c4c4c4',
  BorderColorMinusHover: '#394040',
  BorderColorMinusDown: '#1a3e6d',
  BorderColorInverseHover: '#394040',
  BorderColorInverseDown: '#1a3e6d',
  BorderColorActionsDefault: 'rgba(0, 0, 0, 0)',
  BorderColorActionsHover: '#c4c4c4',
  BorderColorActionsDown: '#394040',
  BorderColorFilterDefault: '#c4c4c4',
  BorderColorFilterHover: '#394040',
  BorderColorFilterDown: '#1a3e6d',
  BorderColorFilterActive: '#1c2222',
  FontSizeBaseDefault: '14px',
  FontSizeMiniDefault: '12px',
  FontSizeSmallDefault: '12px',
  FontWeightBaseDefault: '500',
  FontWeightLinkDefault: '400',
  FontColorBaseDefault: '#1c2222',
  FontColorBaseHover: '#394040',
  FontColorBaseDown: '#1a3e6d',
  FontColorBaseDisabled: '#a7aaaa',
  FontColorSecondaryDefault: '#1c2222',
  FontColorSecondaryHover: '#394040',
  FontColorSecondaryDown: '#1a3e6d',
  FontColorSecondaryDisabled: '#a7aaaa',
  FontColorPrimaryDefault: '#ebecec',
  FontColorPrimaryDisabled: '#a7aaaa',
  FontColorDangerDefault: '#ebecec',
  FontColorDangerDisabled: '#e9778a',
  FontColorTransparentDefault: '#1c2222',
  FontColorTransparentHover: '#394040',
  FontColorTransparentDown: '#1a3e6d',
  FontColorTransparentDisabled: '#1c2222',
  FontColorLinkDefault: '#285da3',
  FontColorLinkHover: '#1a3e6d',
  FontColorLinkDown: '#1a3e6d',
  FontColorLinkDisabled: '#a7aaaa',
  FontColorLinkInverse: '#8babd6',
  FontColorActionsDefault: '#232b2b',
  FontColorInverseDefault: '#1c2222',
  FontColorInverseHover: '#394040',
  FontColorInverseDown: '#1a3e6d',
  FontColorPlusDefault: '#ebecec',
  FontColorMinusDefault: '#1c2222',
  FontColorMinusHover: '#394040',
  FontColorMinusDown: '#1a3e6d',
  FontColorFilterDefault: '#1c2222',
  FontColorFilterHover: '#394040',
  FontColorFilterDown: '#1a3e6d',
  FontColorFilterActive: '#1c2222',
  FontColorFilterDisabled: '#a7aaaa',
  FontDecorationLinkDefault: 'underline',
  ShadowSecondaryHover: 'inset 0 -2px 2px -1px', // depth only, color assignment necessary
  ShadowSecondaryDown: 'inset 0 2px 2px -1px', // depth only, color assignment necessary
  ShadowSecondaryKeyboardFocus: '0px 0px 9px 0px #285da3', // same for all variants
  ShadowWidthBaseKeyboardFocus: '4px',
  ShadowColorBaseKeyboardFocus: '#8babd6',
  ShadowColorDangerKeyboardFocus: '#e9778a',
  OutlineOffsetSecondaryDefault: '2px',
  OutlineStrokeSecondaryKeyboardFocus: '2px solid',
  OutlineColorSecondaryKeyboardFocus: '#285da3',
  OutlineColorInverseKeyboardFocus: '#285da3',
  SpacingHorizontalPlusDefault: '4px',
  SpacingHorizontalMinusDefault: '4px',
  SpacingHorizontalAutoDefault: '12px',
  SpacingHorizontalCellDefault: '12px',
  SpacingHorizontalMiniDefault: '8px',
  SpacingHorizontalSmallDefault: '12px',
  SpacingHorizontalWideDefault: '74px',
  SpacingHorizontalMediumDefault: '12px',
  SpacingHorizontalFilterDefault: '12px',
  SpacingHorizontalFilterActive: '11.5px',
  OpacityTransparentDisabled: '0.5',
  OpacityAuraDisabled: '0.5',
  SizeWidthActionsDefault: '26px',
  SizeHeightAutoDefault: '42px',
  SizeHeightFullDefault: '42px',
  SizeHeightWideDefault: '42px',
  SizeHeightMediumDefault: '34px',
  SizeHeightCellDefault: '29px',
  SizeHeightActionsDefault: '26px',
  SizeHeightSmallDefault: '32px',
  SizeHeightMinusDefault: '16px',
  SizeHeightPlusDefault: '16px',
} as const;
